// src/components/Footer.jsx
import React from "react";
import { useTranslation } from "react-i18next";
const Footer = () => {
    const { t } = useTranslation();
  return (
    <footer className="bg-[#E0F2FF] text-center text-sm text-[#003B5C] py-4  border-t border-blue-200">
      © {new Date().getFullYear()} {t("footer")}
    </footer>
  );
};

export default Footer;